const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

export default state
